import { GroupWork, YouTube, Speed } from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

export interface FeatureDefinition {
  title: string;
  description: string;
  icon: SvgIconComponent;
}

export const homeFeatures: FeatureDefinition[] = [
  {
    title: 'Smart Channel Groups',
    description:
      'Create custom groups to organize your YouTube subscriptions by topic, creator type, or any category you prefer.',
    icon: GroupWork,
  },
  {
    title: 'YouTube Integration',
    description: 'Seamlessly syncs with your YouTube account to fetch all your subscriptions automatically.',
    icon: YouTube,
  },
  {
    title: 'Lightning Fast',
    description: 'Instant updates and real-time synchronization ensure you never miss new content from your groups.',
    icon: Speed,
  },
];
